module.exports = __webpack_public_path__ + "img/3.e73a0780.png";